<template>
  <sea-page title="Attivazione utenza">
    <v-card max-width="500" class="mx-auto">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" :value="!error && !success && !keyMissing">
                <p class="text-body-2 text-md-body-1">
                  Attivazione utenza. Inserire Username e password per l’account da attivare.
                </p>
              </v-alert>
              <v-alert type="error" :value="error">
                {{ title }}
              </v-alert>
              <v-alert type="success" :value="success">
                <span class="font-weight-bold">
                  I dati sono stati aggiornati con successo.<br />
                  Effettua il
                </span>
                <router-link to="/" style="color: white"> log in</router-link>
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="!success && !keyMissing">
              <p class="text-caption" style="word-break: keep-all">
                *{{ pwdPolicyRules }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <form
        v-if="!success"
        name="form"
        role="form"
        @submit.prevent="doActivate()"
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="10" offset="1"
                ><v-text-field
                  label="Username"
                  placeholder="Username"
                  type="text"
                  v-model="activateAccount.username"
                  :error-messages="errors('username')"
                  @input="$v.activateAccount.username.$touch()"
                  @blur="$v.activateAccount.username.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="10" offset="1">
                <v-text-field
                  label="Password"
                  placeholder="Password"
                  :type="pwdVisible ? 'text' : 'password'"
                  v-model="activateAccount.newPassword"
                  minlength="8"
                  maxlength="100"
                  required
                  :error-messages="errors('newPassword')"
                  @input="$v.activateAccount.newPassword.$touch()"
                  @blur="$v.activateAccount.newPassword.$touch()"
                >
                  <template v-slot:append>
                    <v-icon
                      style="cursor: pointer"
                      @click="pwdVisible = !pwdVisible"
                      >{{ pwdVisible ? "mdi-eye-off" : "mdi-eye" }}</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="10" offset="1"
                ><v-text-field
                  label="Conferma password"
                  placeholder="Conferma password"
                  :type="pwdVisible ? 'text' : 'password'"
                  v-model="activateAccount.confirmPassword"
                  :error-messages="errors('confirmPassword')"
                  @input="$v.activateAccount.confirmPassword.$touch()"
                  @blur="$v.activateAccount.confirmPassword.$touch()"
                ></v-text-field>
              </v-col>
              <v-col v-if="profileType == false" cols="10" offset="1">
                <div class="d-flex flex-row align-center">
                  <input
                    type="checkbox"
                    v-model="privacy"
                    @change="privacyError = !privacy"
                  />
                  <div
                    class="
                      ml-2
                      font-weight-bold
                      text-body-2 text-decoration-underline
                    "
                  >
                    Ho letto e accettato l'informativa sulla
                    <a style="color: blue" @click.stop="downloadPrivacy"
                      >Privacy</a
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions v-if="profileType == false"> 
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="blue darken-1"
            :disabled="$v.activateAccount.$invalid || !privacy"
            text
            v-if="!success"
          >
            Attiva azienda
          </v-btn>
        </v-card-actions>
        <v-card-actions v-if="profileType == true">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="blue darken-1"
            :disabled="$v.activateAccount.$invalid"
            text
            v-if="!success"
          >
            Attiva consulente
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </sea-page>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import mixin from "@/mixin";
import { PASSWORD_POLICY } from "@/constants";

export default {
  mixins: [mixin, validationMixin],
  validations: {
    activateAccount: {
      username: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(100),
      },
      confirmPassword: { sameAsPassword: sameAs("newPassword") },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.key) {
        vm.key = to.query.key;
        vm.keyMissing = false;
      } else {
        vm.keyMissing = true;
      }
    });
  },
  mounted() {
    this.companyData({key: this.key}).then((res) => {
        //debugger;
        if (res.success) {
          this.company = res.data;
          if(res.data == "") {
            this.profileType = true //consulente
          } else this.profileType = false; //azienda
          console.log("profile", this.profileType)
        } else {
          console.log("Errore status ", res.status);
        }
      });
  },
  data() {
    return {
      profileType: false,
      pwdPolicyRules: PASSWORD_POLICY,
      pwdVisible: false,
      success: null,
      error: null,
      title: null,
      keyMissing: null,
      privacy: false,
      privacyError: false,
      key: null,
      activateAccount: {
        username: null,
        newPassword: null,
        confirmPassword: null,
      },
    };
  },
  methods: {
    errors(fieldName) {
      const errors = [];
      if (!this.$v.activateAccount[fieldName].$dirty) return errors;
      if (fieldName === "newPassword") {
        !this.$v.activateAccount.newPassword.required &&
          errors.push(this.locales.required);
        !this.$v.activateAccount.newPassword.minLength &&
          errors.push(this.locales.minLength(8));
        !this.$v.activateAccount.newPassword.maxLength &&
          errors.push(this.locales.maxLength(100));
      } else if (fieldName === "username") {
        !this.$v.activateAccount.username.required &&
          errors.push(this.locales.required);
      } else if (fieldName === "confirmPassword") {
        !this.$v.activateAccount.confirmPassword.sameAsPassword &&
          errors.push(this.locales.sameAs);
      }
      return errors;
    },
    doActivate() { //ok
      if(this.profileType == false) {
        if (!this.privacy) {
          this.privacyError = true;
        }
        this.$v.$touch();
        if (!this.$v.activateAccount.$invalid && this.privacy) {
          this.activate({
            key: this.key,
            username: this.activateAccount.username,
            password: this.activateAccount.newPassword,
          }).then((res) => {
            this.success = res.success;
            this.error = !res.success;
            this.title = res.status === 400 ? res.title : res.detail;
          });
        }        
      } else {
        this.$v.$touch();
        if (!this.$v.activateAccount.$invalid) {
          this.activate({
            key: this.key,
            username: this.activateAccount.username,
            password: this.activateAccount.newPassword,
          }).then((res) => {
            this.success = res.success;
            this.error = !res.success;
            this.title = res.status === 400 ? res.title : res.detail;
          });
        }    
      }

    },
    downloadPrivacy() {
      const r = this.$router.resolve({
        name: 'PrivacyCompany',
      });
      window.open(r.href, "_blank");
    },   
    ...mapActions({
      activate: "account/activateAccount",
      companyData: "account/privacyActivate",
    }),
  },
};
</script>

<style scoped>
a {
  font-weight: bolder;
  color: #ffffff;
}
p {
  word-break: keep-all;
}
</style>